import request from '@/utils/request'
export const Download = "/workflow/system/sign/approval/export";

export function queryPage(data) {
  return request({
    url: '/workflow/system/sign/approval/query_page',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/workflow/system/sign/approval/save_or_update',
    method: 'post',
    data
  })
}
export function updateSortNum(data) {
  return request({
    url: '/workflow/system/sign/approval/update_sort_num',
    method: 'post',
    data
  })
}
export function batchUpdateOrDelete(data) {
  return request({
    url: '/workflow/system/sign/approval/batch_update_or_delete',
    method: 'post',
    data
  })
}